import { CircularProgress, Grid, GridProps } from '@mui/material'

export const FullPageLoader: React.FC<GridProps> = (props) => {
  return (
    <Grid container alignItems='center' justifyContent='center' height='100vh' {...props}>
      <CircularProgress />
    </Grid>
  )
}
